import React, { Component } from "react";
import {
  DropdownItem,
  DropdownMenu,
  // DropdownToggle,
  Nav,
} from "reactstrap";
import PropTypes from "prop-types";

import {
  AppHeaderDropdown,
  AppNavbarBrand,
  AppSidebarToggler
} from "@coreui/react";
import logo from "../../assets/img/brand/logo.png";
import sygnet from "../../assets/img/brand/mini-logo.png";
import mute from "../../assets/sounds/mute.mp3"
import bell from "../../assets/sounds/bell.mp3"
import RequestManager from "../../singletons/RequestManager";
import noticationlogo from "../../assets/img/brand/highlighted-logo.png";
import {generateEpochTimestamp, generateSignature} from "../../utils/helper";
import {
  TIME_INTERVAL_ORDER,
} from "../../config/Constants";
import config from "../../config";

const propTypes = {
  children: PropTypes.node
};

const defaultProps = {};
let player;

class DefaultHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      storeName: "",
      imgLogo:"",
    };
  }
  componentDidMount() {
    this.getStoreName();
    if ("Notification" in window && Notification.permission !== "granted") {
      this.requestNotificationPermission();
    }
    
    try {
    player = document.getElementById("audio");
    }
    catch(error){
      console.log('error on getElementById audio file', error);
    }
    // this.setState({
    //   intervalId: setInterval(get_order_count_for_notification, 30000) // Call API every 30 seconds

    // });
    try {
    this.fetchOrderInterval = setInterval(async () => {
      try {
        await this.get_order_count_for_notification(); // Wrap this in try-catch to handle any errors
      } catch (error) {
        console.error("Error fetching order count:", error);
      }
    }, TIME_INTERVAL_ORDER);
  } catch (error) {  // Correct syntax for catch block
    console.log('Error in setInterval:', error);
  }
   
    // this.get_order_count_for_notification();
  }
  componentWillUnmount() {
   
      clearInterval(this.fetchOrderInterval); // Clear the interval when the component unmounts
   
   
   
  }
  

  requestNotificationPermission = () => {
    if ("Notification" in window) {
      if (Notification.permission === "granted") {
        return true;
      } else if (Notification.permission !== "denied") {
        Notification.requestPermission(function (permission) {
          if (permission === "granted") {
            return true;
          } else {
            return false;
          }
        });
      } else {
        return false;
      }
    }
  }
  render() {
    // eslint-disable-next-line
    const { children, ...attributes } = this.props;

    return (
      <React.Fragment>
        <AppSidebarToggler className="d-lg-none" display="md" mobile />
        <AppNavbarBrand
          full={{ src: this.state.imgLogo !== null && this.state.imgLogo !== '' ? this.state.imgLogo : logo,
             width: 162, height: 31, alt: "Logo" }}
          minimized={{
            src: this.state.imgLogo !== null && this.state.imgLogo !== '' ? this.state.imgLogo : sygnet,
            width: 30,
            height: 30,
            alt: "Logo",
          }}
        />
            {this.state.storeName && (
              <audio
                id="audio"
                style={{ display: "none" }} // Hide the audio element
                preload="auto"
                src={mute}
              />
            )}
        {/* <AppNavbarBrand
          full={{ src: logo, width: 162, height: 31, alt: "GrabbnGo Logo" }}
          minimized={{
            src: sygnet,
            width: 30,
            height: 30,
            alt: "GrabbnGo Logo"
          }}
        /> */}
        {/* <AppSidebarToggler className="d-md-down-none" display="lg" /> */}

        {/* <Nav className="d-md-down-none" navbar>
          <NavItem className="px-3">
            <NavLink href="/">Dashboard</NavLink>
          </NavItem>
          <NavItem className="px-3">
            <NavLink href="#">Users</NavLink>
          </NavItem>
          <NavItem className="px-3">
            <NavLink href="#">Settings</NavLink>
          </NavItem>
        </Nav> */}
        <Nav className="ml-auto" navbar>
          {/* <NavItem className="d-md-down-none">
            <NavLink href="#"><i className="icon-bell"></i><Badge pill color="danger">5</Badge></NavLink>
          </NavItem>
          <NavItem className="d-md-down-none">
            <NavLink href="#"><i className="icon-list"></i></NavLink>
          </NavItem>
          <NavItem className="d-md-down-none">
            <NavLink href="#"><i className="icon-location-pin"></i></NavLink>
          </NavItem> */}
          <AppHeaderDropdown direction="down">
            {
              /* 
            <DropdownToggle nav>
              <img
                src={"assets/img/settings.png"}
                className="img-avatar"
                alt="admin@bootstrapmaster.com"
              />
            </DropdownToggle> */}
            <DropdownMenu right style={{ right: "auto" }}>
              {/* <DropdownItem header tag="div" className="text-center"><strong>Account</strong></DropdownItem>
              <DropdownItem><i className="fa fa-bell-o"></i> Updates<Badge color="info">42</Badge></DropdownItem>
              <DropdownItem><i className="fa fa-envelope-o"></i> Messages<Badge color="success">42</Badge></DropdownItem>
              <DropdownItem><i className="fa fa-tasks"></i> Tasks<Badge color="danger">42</Badge></DropdownItem>
              <DropdownItem><i className="fa fa-comments"></i> Comments<Badge color="warning">42</Badge></DropdownItem>
              <DropdownItem header tag="div" className="text-center"><strong>Settings</strong></DropdownItem>
              <DropdownItem><i className="fa fa-user"></i> Profile</DropdownItem>
              <DropdownItem><i className="fa fa-wrench"></i> Settings</DropdownItem>
              <DropdownItem><i className="fa fa-usd"></i> Payments<Badge color="secondary">42</Badge></DropdownItem>
              <DropdownItem><i className="fa fa-file"></i> Projects<Badge color="primary">42</Badge></DropdownItem>
              <DropdownItem divider />
              <DropdownItem><i className="fa fa-shield"></i> Lock Account</DropdownItem> */}
              {this.state.storeName === "" ? null : (
                <DropdownItem>
                  <i className="fa fa-lock" /> {this.state.storeName}{" "}
                </DropdownItem>
              )}
              
              
              
              

              <DropdownItem onClick={this.props.onLogout}>
                <i className="fa fa-lock" /> Logout
              </DropdownItem>
            </DropdownMenu>
          </AppHeaderDropdown>
        </Nav>
        {/* <AppAsideToggler className="d-md-down-none" /> */}
        {/*<AppAsideToggler className="d-lg-none" mobile />*/}
      </React.Fragment>
    );
  }

  getStoreName = async () => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    console.log('storeInformation',storeInformation);
    console.log('storeInformation.user.image', storeInformation.user.image);
    let loginMode = localStorage.getItem("loginMode");
    this.setState({
      imgLogo : storeInformation.user.image,
    });
    if (loginMode === "store") {
      this.setState({
        storeName: storeInformation.store && storeInformation.store.name,
        imgLogo : storeInformation.user.image,
      });
    } else if (loginMode === "merchant") {
      this.setState({
        storeName: storeInformation.merchant && storeInformation.merchant.name,
        imgLogo : storeInformation.user.image,
      });
    } else if (loginMode === "concessionaire") {
      this.setState({
      imgLogo : storeInformation.user.image,
    });
    }
  };

  get_order_count_for_notification = async () =>{
    try {
      let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
      let authToken = storeInformation.token;
      var vtimestamp = generateEpochTimestamp();
      let response = await fetch(
          config.getHost() + "/order/getordercountfornotifications/",
          {
            method: "POST",
            headers: {
              Authorization: `Token ${authToken}`,
              "Content-Type": "application/json",
              Timestamp: vtimestamp,
              Signature: generateSignature(vtimestamp, authToken)                
            },
            body: JSON.stringify({
              store_id: storeInformation.store && storeInformation.store.id,
              graphql:true
            }),
          }
        );
  
      console.log("Response", response);
  
      if (response.status === 200) {
        let result = await response.json();
        if (result.SUCCESS) {
          let orderCount = result.ORDER_COUNT;
          console.log("Order Count:", orderCount);
  
          // Trigger a notification if there are new orders
          if (typeof orderCount === "number" && orderCount > 0)  {
            // showNotification("New Orders", `You have ${orderCount} new order(s)!, Please accept it`);
            this.showNotification("New Orders", `You have new order(s)! at your store, Please accept it`);
            try{
            this.playSound();
            }catch(error){
              console.log("error in calling sound", error);        
            }
            // this.playSound();
          }
        }  
      } else {
        console.log("res", response.status);
      }
    } catch (error) {
      console.log("error", error);
  }
  };
  
  showNotification = (title, message) => {
    try{
    if (Notification.permission === "granted") {
      new Notification(title, { body: message, icon: noticationlogo });
    } else if (Notification.permission !== "denied") {
      Notification.requestPermission().then(permission => {
        if (permission === "granted") {
          new Notification(title, { body: message, icon :noticationlogo, });
        }
      });
    }
  }
  catch(error){
    console.log('error in showNotification',error )
  }
  };
  
  playSound = () => {
    try {
    if (player) {
      if (player.paused) {
        // let requestManager = new RequestManager();
        // let sound = requestManager.getSoundFile();
        // console.log("Playing sound: " + sound);
        try {
          // player.src = require(`../../assets/sounds/${sound}.mp3`);
          player.src = bell;
          player.load();
  
          // Set volume to full
          player.volume = 1;
  
          player.play().catch(error => console.error("Error playing sound:", error));
        } catch (error) {
          console.error("Error loading sound file 1:", error);
        }
      }

    } else {
      console.error("Player is null. Cannot play sound.");
      try {
        player = document.getElementById("audio");
        }
        catch(error){
          console.log('error on getElementById audio file', error);
        }
    }

  } catch (error) {
    console.error("Error loading sound file 2:", error);
  }
  };
  

}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

export default DefaultHeader;



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultHeader.js